import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-planter-form-modal',
  templateUrl: './planter-form-modal.component.html',
  styleUrls: ['./planter-form-modal.component.scss']
})
export class PlanterFormModalComponent implements OnInit {

  form: FormGroup;
  title: string;
  subtitle: string;

  constructor(private fb: FormBuilder,
              private dialogRef: MatDialogRef<PlanterFormModalComponent>,
              @Inject(MAT_DIALOG_DATA) data) {
                console.log('data',data)
                this.title = data.title;
                this.subtitle = data.subtitle;
              }

  ngOnInit() {
    this.form = this.fb.group({
        description: ['', [
            Validators.required,
            Validators.minLength(5).bind(this)
        ]]
    })
  }

  sendData() {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }

  closeModal() {
      this.dialogRef.close(null)
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modals/planter-form-modal/planter-form-modal.component.ts